import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable, of as _observableOf, throwError as _observableThrow } from 'rxjs';
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';
import { CommonFunctions } from '../common-functions';
import { Admin_Dashboard_Daily_AttendanceListApiResponse } from '../models/admin-dashboard-daily-attendance-list-api-response.model';
import { Admin_Dashboard_Daily_Late_EarlyListApiResponse } from '../models/admin-dashboard-daily-late-early-list-api-response.model';
import { Admin_Dashboard_Daily_Leave_ApplicationListApiResponse } from '../models/admin-dashboard-daily-leave-application-list-api-response.model';
import { Admin_Dashboard_Daily_Present_Absent_Location_WiseListApiResponse } from '../models/admin-dashboard-daily-present-absent-location-wise-list-api-response.model';
import { Admin_Dashboard_Daily_Present_AbsentApiResponse } from '../models/admin-dashboard-daily-present-absent-api-response.model';
import { Admin_Dashboard_Monthly_Late_EarlyListApiResponse } from '../models/admin-dashboard-monthly-late-early-list-api-response.model';
import { Admin_Dashboard_Upcomming_AnniversaryListApiResponse } from '../models/admin-dashboard-upcomming-anniversary-list-api-response.model';
import { Admin_Dashboard_Upcomming_BirthdayListApiResponse } from '../models/admin-dashboard-upcomming-birthday-list-api-response.model';
import { Admin_Dashboard_Upcomming_HolidayListApiResponse } from '../models/admin-dashboard-upcomming-holiday-list-api-response.model';
import { Admin_Dashboard_UpComming_IncrementListApiResponse } from '../models/admin-dashboard-up-comming-increment-list-api-response.model';
import { API_BASE_URL } from '../service-proxies';

@Injectable()
export class AdminDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(private _commonFunctions: CommonFunctions, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUpCommingBirthDay(): Observable<Admin_Dashboard_Upcomming_BirthdayListApiResponse> {
        let url_ = this.baseUrl + "/api/AdminDashboard/GetUpCommingBirthDay";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpCommingBirthDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpCommingBirthDay(<any>response_);
                } catch (e) {
                    return <Observable<Admin_Dashboard_Upcomming_BirthdayListApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Admin_Dashboard_Upcomming_BirthdayListApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetUpCommingBirthDay(response: HttpResponseBase): Observable<Admin_Dashboard_Upcomming_BirthdayListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Admin_Dashboard_Upcomming_BirthdayListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Admin_Dashboard_Upcomming_BirthdayListApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getUpCommingAnniversary(): Observable<Admin_Dashboard_Upcomming_AnniversaryListApiResponse> {
        let url_ = this.baseUrl + "/api/AdminDashboard/getUpCommingAnniversary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpCommingAnniversary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpCommingAnniversary(<any>response_);
                } catch (e) {
                    return <Observable<Admin_Dashboard_Upcomming_AnniversaryListApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Admin_Dashboard_Upcomming_AnniversaryListApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetUpCommingAnniversary(response: HttpResponseBase): Observable<Admin_Dashboard_Upcomming_AnniversaryListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Admin_Dashboard_Upcomming_AnniversaryListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Admin_Dashboard_Upcomming_AnniversaryListApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getUpCommingHoliday(): Observable<Admin_Dashboard_Upcomming_HolidayListApiResponse> {
        let url_ = this.baseUrl + "/api/AdminDashboard/getUpCommingHoliday";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpCommingHoliday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpCommingHoliday(<any>response_);
                } catch (e) {
                    return <Observable<Admin_Dashboard_Upcomming_HolidayListApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Admin_Dashboard_Upcomming_HolidayListApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetUpCommingHoliday(response: HttpResponseBase): Observable<Admin_Dashboard_Upcomming_HolidayListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Admin_Dashboard_Upcomming_HolidayListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Admin_Dashboard_Upcomming_HolidayListApiResponse>(<any>null);
    }

    /**
     * @param toDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getDailyLeaveApplication(toDate: Date | undefined, endDate: Date | undefined): Observable<Admin_Dashboard_Daily_Leave_ApplicationListApiResponse> {
        let url_ = this.baseUrl + "/api/AdminDashboard/getDailyLeaveApplication?";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyLeaveApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyLeaveApplication(<any>response_);
                } catch (e) {
                    return <Observable<Admin_Dashboard_Daily_Leave_ApplicationListApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Admin_Dashboard_Daily_Leave_ApplicationListApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetDailyLeaveApplication(response: HttpResponseBase): Observable<Admin_Dashboard_Daily_Leave_ApplicationListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Admin_Dashboard_Daily_Leave_ApplicationListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Admin_Dashboard_Daily_Leave_ApplicationListApiResponse>(<any>null);
    }

    /**
     * @param toDate (optional) 
     * @return Success
     */
    getDailyPresentAbsent(toDate: Date | undefined): Observable<Admin_Dashboard_Daily_Present_AbsentApiResponse> {
        let url_ = this.baseUrl + "/api/AdminDashboard/getDailyPresentAbsent?";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyPresentAbsent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyPresentAbsent(<any>response_);
                } catch (e) {
                    return <Observable<Admin_Dashboard_Daily_Present_AbsentApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Admin_Dashboard_Daily_Present_AbsentApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetDailyPresentAbsent(response: HttpResponseBase): Observable<Admin_Dashboard_Daily_Present_AbsentApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Admin_Dashboard_Daily_Present_AbsentApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Admin_Dashboard_Daily_Present_AbsentApiResponse>(<any>null);
    }

    /**
     * @param toDate (optional) 
     * @return Success
     */
    getDailyLateEarly(toDate: Date | undefined): Observable<Admin_Dashboard_Daily_Late_EarlyListApiResponse> {
        let url_ = this.baseUrl + "/api/AdminDashboard/getDailyLateEarly?";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyLateEarly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyLateEarly(<any>response_);
                } catch (e) {
                    return <Observable<Admin_Dashboard_Daily_Late_EarlyListApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Admin_Dashboard_Daily_Late_EarlyListApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetDailyLateEarly(response: HttpResponseBase): Observable<Admin_Dashboard_Daily_Late_EarlyListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Admin_Dashboard_Daily_Late_EarlyListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Admin_Dashboard_Daily_Late_EarlyListApiResponse>(<any>null);
    }

    /**
     * @param toDate (optional) 
     * @return Success
     */
    getDailyAttendance(toDate: Date | undefined): Observable<Admin_Dashboard_Daily_AttendanceListApiResponse> {
        let url_ = this.baseUrl + "/api/AdminDashboard/getDailyAttendance?";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyAttendance(<any>response_);
                } catch (e) {
                    return <Observable<Admin_Dashboard_Daily_AttendanceListApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Admin_Dashboard_Daily_AttendanceListApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetDailyAttendance(response: HttpResponseBase): Observable<Admin_Dashboard_Daily_AttendanceListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Admin_Dashboard_Daily_AttendanceListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Admin_Dashboard_Daily_AttendanceListApiResponse>(<any>null);
    }

    /**
     * @param toDate (optional) 
     * @return Success
     */
    getUpCommingIncrement(toDate: Date | undefined): Observable<Admin_Dashboard_UpComming_IncrementListApiResponse> {
        let url_ = this.baseUrl + "/api/AdminDashboard/getUpCommingIncrement?";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpCommingIncrement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpCommingIncrement(<any>response_);
                } catch (e) {
                    return <Observable<Admin_Dashboard_UpComming_IncrementListApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Admin_Dashboard_UpComming_IncrementListApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetUpCommingIncrement(response: HttpResponseBase): Observable<Admin_Dashboard_UpComming_IncrementListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Admin_Dashboard_UpComming_IncrementListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Admin_Dashboard_UpComming_IncrementListApiResponse>(<any>null);
    }

    /**
     * @param toDate (optional) 
     * @return Success
     */
    getDailyPresentAbsentLocationWise(toDate: Date | undefined): Observable<Admin_Dashboard_Daily_Present_Absent_Location_WiseListApiResponse> {
        let url_ = this.baseUrl + "/api/AdminDashboard/getDailyPresentAbsentLocationWise?";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyPresentAbsentLocationWise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyPresentAbsentLocationWise(<any>response_);
                } catch (e) {
                    return <Observable<Admin_Dashboard_Daily_Present_Absent_Location_WiseListApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Admin_Dashboard_Daily_Present_Absent_Location_WiseListApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetDailyPresentAbsentLocationWise(response: HttpResponseBase): Observable<Admin_Dashboard_Daily_Present_Absent_Location_WiseListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Admin_Dashboard_Daily_Present_Absent_Location_WiseListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Admin_Dashboard_Daily_Present_Absent_Location_WiseListApiResponse>(<any>null);
    }

    /**
     * @param toDate (optional) 
     * @return Success
     */
    getMonthlyLateEarly(toDate: Date | undefined): Observable<Admin_Dashboard_Monthly_Late_EarlyListApiResponse> {
        let url_ = this.baseUrl + "/api/AdminDashboard/getMonthlyLateEarly?";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyLateEarly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyLateEarly(<any>response_);
                } catch (e) {
                    return <Observable<Admin_Dashboard_Monthly_Late_EarlyListApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Admin_Dashboard_Monthly_Late_EarlyListApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetMonthlyLateEarly(response: HttpResponseBase): Observable<Admin_Dashboard_Monthly_Late_EarlyListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Admin_Dashboard_Monthly_Late_EarlyListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Admin_Dashboard_Monthly_Late_EarlyListApiResponse>(<any>null);
    }
}
